import React, { Component,Fragment,useEffect,useState } from "react";
import { bindActionCreators } from "redux";
import { connect , useSelector } from "react-redux";
import toastr from "toastr";
import * as R from 'ramda';
import moment from "moment";
import { Card, CardHeader,CardTitle,CardBody } from "reactstrap";
import Select from "react-select-nested-group";
import Things from "../../../ducks/Things";
import ReactSpeedometer from "react-d3-speedometer";
import DateTime from 'react-datetime';
import { Spinner } from '../../common/Spinner';
import "./index.css";

import {
  LineChart,
  ResponsiveContainer,
  BarChart, Bar,
  XAxis,
  ReferenceLine,
  Legend,
  CartesianGrid,
  YAxis,
  Tooltip,
  Line
} from "recharts";

  const Temperature = props => {

    const filters = [
      { value: "company", label: "Company" },
      { value : "idividual" , label : "Individual Thing"}
    ];

    const companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    const [companyId, setCompanyId] = useState(companyInfo ? companyInfo.companyId : "");
    const [things, setThings] = useState([]);
    const [selectedThing, setSelectedThing] = useState('');
    const [selectedStartDate, setSelectedStartDate] = useState(moment());
    const [selectedEndDate, setSelectedEndDate] = useState(moment());
    const [selectedFilter , setSelectedFilter] = useState(filters[0]);
    const [screenDisplay, setScreenDisplay] = useState('company');
    const [isloader, setIsloader] = useState(false);
    const temperature = useSelector( state => state?.things?.TemperaturesData);
    const SingleTemperatureData = useSelector( state => state?.things?.SingleTemperatureData);
    const actions = [props.actions.fetchThings(true)];

    useEffect(() => {
      setIsloader(true);
      loadThings();
      actions.push(props.actions.getCompanyTemperatureObservations(companyId));
    },[]);

    const loadThings = async () => {
      const things = await props.actions.fetchThings();
      const mappedValues = R.map(thing => ({ 'id':thing._id,value: thing.name, label: `${thing.plateNumber || 'N/A'}` }))(things);
      setThings(mappedValues);
    };

    const  handleRouterChange = (option) => {
      setSelectedThing(option);
    };

    const  onSubmit = (option) => {

      if (selectedFilter.value == "idividual"){
        if (!selectedThing){
          return toastr.error("Please Select Thing");
        };

        let startDate = selectedStartDate['_d'];
        let endDate = selectedEndDate['_d'];

        let diff = endDate - startDate;
        let finalDiff = Math.ceil(diff/ (1000 * 60 * 60));
        if (finalDiff > 24 ) {
          return toastr.error("Duration Should be 1 Day Maximum");
        }
        setIsloader(true);
  
        let interval = {
                'startDate' : moment(startDate),
                'endDate':moment(endDate)
        };
        actions.push(props.actions.getIndividualTemepratureObservations(selectedThing.id, JSON.stringify({ interval })));

      } else {
        setIsloader(true);
        actions.push(props.actions.getCompanyTemperatureObservations(companyId));
      }
    };

    const textColor = '#AAA'

    const  handleRouterClick = (event) => {
    };

    const  handleFilterChange = (option) => {
      setSelectedFilter(option);
      if (option?.value == "idividual"){
        let hours = selectedStartDate['_d'].getHours();
        selectedStartDate['_d'].setHours(hours - 1);
        setSelectedStartDate(selectedStartDate);
        return setScreenDisplay('idividual');
      } else {
        return setScreenDisplay('company');
      }
    };

    useEffect(() => {
      if (SingleTemperatureData?.data || temperature?.data){
        setIsloader(false);
      }
    },[SingleTemperatureData,temperature]);


    return (
      <div className="routerData">
        <div className="row" style={{ margin: '20px',    marginBottom: "20px" }}>
          <span className="mainHeader">Temperature </span>
        </div>
        <div className="row" style={{ margin: '20px',    marginBottom: "30px" }}>
          <Card style={{ height: "140px" ,flexDirection: "column", minWidth: "100%" }}>
            <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">Search </CardHeader>
            <div className="searchDiv" >
              <div className="col-lg-2 col-sm-2">
                <label>Select Filter</label>
                <Select
                  name="form-field-selectedThing"
                  value={selectedFilter}
                  searchable={true}
                  onChange={handleFilterChange}
                  options={filters} />
              </div>
              { selectedFilter?.value == "company" ? (
                <div className="col-lg-2" style={{ padding: '25px 0 0 25px' }}>
                  <button className={`btn btn-primary search-btn  search-button`} onClick={onSubmit}>Search</button>
                </div>
              ) :(
                <Fragment>
                  <div className="col-lg-2 col-sm-2">
                    <label>Select Thing</label>
                    <Select
                      name="form-field-selectedThing"
                      value={selectedThing}
                      searchable={true}
                      onChange={handleRouterChange}
                      options={things} />
                  </div>
                  <div className="col-lg-2 col-sm-2" >
                    <label>Start Date</label>
                    <DateTime value={selectedStartDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={setSelectedStartDate} />
                  </div>
                  <div className="col-lg-2 col-sm-2" >
                    <label>End Date</label>
                    <DateTime value={selectedEndDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={setSelectedEndDate} />
                  </div>
                  <div className="col-lg-2" style={{ padding: '25px 0 0 25px' }}>
                    <button className={`btn btn-primary search-btn  search-button`} onClick={onSubmit}>Search</button>
                  </div>
                </Fragment>
              )}
            </div>
          </Card>
          
        </div>
                  <div className="contentDiv">
                  { !isloader && temperature?.data?.data?.length && screenDisplay == "company"  ?  (
                    <div>
                      <div className="chartDiv">
                        <Card style={{height:"390px",paddingBottom:"10px",flexDirection: "column", minWidth: "100%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">Temperature</CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <BarChart  width={1020} height={250} data={temperature?.data?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis onClick={handleRouterClick} dataKey="thing" label={{
                                value: "Things",
                                position: "insideBottomLeft",
                                offset: -8,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <YAxis label={{
                                value: "Temperature",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              <ReferenceLine y={0} stroke="#000" />
                              <Bar dataKey="temperature" fill="#8884d8" />
                            </BarChart >
                          </ResponsiveContainer>              
                        </Card>
                      </div>
                    </div>
                  ) : isloader && screenDisplay == "company" ? <div style={{'marginTop': '20%'}}><Spinner/></div> : screenDisplay == "company" && 'There is no data To Display'}
               
                  { !isloader && SingleTemperatureData?.data?.data?.length && screenDisplay == "idividual" ? (
                    <div>
                      <div className="TemperatureChartDiv">
                        <Card style={{height:"320px",paddingBottom:"10px",flexDirection: "column", minWidth: "100%" }}>
                        <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">Temperature </CardHeader>
                        <div className="row" style={{justifyContent: 'center'}}>
                          <div className="maintainance-card  temperatureRow row col-lg-4 col-sm-4">
                            <div className={"card-display maintainance-card-width temperatureParent"}>
                              <div className="labelDiv">
                                  <label className="labelText">Average Temperature</label>
                                </div>
                                <ReactSpeedometer
                                  maxValue={50}
                                  minValue={-50}
                                  value={SingleTemperatureData?.data?.avg}
                                  needleColor="#9A3334"
                                  segmentColors={["#0339ce","#035bce","#0365ce","#0380ce","#03abce","#ff7300","#ff6600","#ff4d00","#ff2f00","#FF0000"]}
                                  startColor="#03abce"
                                  segments={11}
                                  endColor="#FF0000"
                                  textColor="grey"
                                  valueTextFontSize="18px"
                                />
                            </div>
                          </div>
                          <div className="maintainance-card  temperatureRow row col-lg-4 col-sm-4">
                            <div className={"card-display maintainance-card-width temperatureParent"}>
                              <div className="labelDiv">
                                  <label className="labelText">Last Value</label>
                                </div>
                                <ReactSpeedometer
                                  maxValue={50}
                                  minValue={-50}
                                  value={SingleTemperatureData?.data?.data[SingleTemperatureData?.data?.data?.length-1]?.temperature}
                                  needleColor="#9A3334"
                                  segmentColors={["#0339ce","#035bce","#0365ce","#0380ce","#03abce","#ff7300","#ff6600","#ff4d00","#ff2f00","#FF0000"]}
                                  startColor="#03abce"
                                  segments={11}
                                  endColor="#FF0000"
                                  textColor="grey"
                                  valueTextFontSize="18px"
                                />
                            </div>
                          </div>
                        </div>
                        </Card>
                      </div>
                      <div className="chartDiv">
                        <Card style={{height:"390px",paddingBottom:"10px",flexDirection: "column", minWidth: "100%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">History</CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart width={1020} height={250} data={SingleTemperatureData?.data?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis label={{
                                value: "Temperature C'",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              <Line type="monotone" dataKey="temperature" stroke="#03abce" />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                      </div>
                      </div>
                  ) : isloader && screenDisplay == "idividual" ? <div style={{'marginTop': '20%'}}><Spinner/></div> : screenDisplay == "idividual" && 'There is no data To Display'}
                </div>
      </div>
    );
}

const mapStateToProps = (state) => {
  return {
    temperature: state?.things?.chartsData
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Things.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(Temperature);
